import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef, metricDetailsRouteRef } from './routes';

export const engineeringInsightsPlugin = createPlugin({
  id: 'engineering-insights',
  routes: {
    root: rootRouteRef,
    metricDetails: metricDetailsRouteRef,
  },
});

export const EngineeringInsightsPage = engineeringInsightsPlugin.provide(
  createRoutableExtension({
    name: 'EngineeringInsightsPage',
    component: () =>
      import('./components/pages/HomePage/HomePage').then(m => m.HomePage),
    mountPoint: rootRouteRef,
  }),
);

export const MetricDetailsPage = engineeringInsightsPlugin.provide(
  createRoutableExtension({
    name: 'MetricDetailsPage',
    component: () =>
      import('./components/pages/MetricDetailsPage/MetricDetailsPage').then(
        m => m.MetricDetailsPage,
      ),
    mountPoint: metricDetailsRouteRef,
  }),
);

export const RepositoryEngineeringInsightsPage =
  engineeringInsightsPlugin.provide(
    createRoutableExtension({
      name: 'RepositoryEngineeringInsightsPage',
      component: () =>
        import('./components/pages/HomePage/RepositoryHomePage').then(
          m => m.RepositoryHomePage,
        ),
      mountPoint: rootRouteRef,
    }),
  );

export const OrganisationInsightsPage = engineeringInsightsPlugin.provide(
  createRoutableExtension({
    name: 'OrganisationInsightsPage',
    component: () =>
      import('./components/pages/HomePage/OrganisationHomePage').then(
        m => m.OrganisationHomePage,
      ),
    mountPoint: rootRouteRef,
  }),
);
